<template>
    <SquareBtn color="default"
               data-component="VoidOrderButton"
               data-analytics-id="Order Details / Void Order"
               :disabled="!isOnline"
               :loading="voiding"
               @click="voidOrder">
        <i class="fa-solid fa-ban"></i>
        {{ l('ORDER_DETAILS.VOID_ORDER_BTN') }}
    </SquareBtn>
</template>

<script>
import EventNames from '@/lib/Events/EventNames';
import PrivilegeNames from '@/lib/Privileges/PrivilegeNames';
import SquareBtn from '@/vue/components/SquareBtn';
import { container } from '@/container';
import { mapState } from 'vuex';

export default {
    components: { SquareBtn },

    props: {
        order: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            voiding: false,
        };
    },

    computed: {
        ...mapState(['isOnline']),
    },

    methods: {
        async voidOrder() {
            // Require permission.
            const result = await container.privilegesManager
                .requirePrivilege(PrivilegeNames.ABANDON_PAYMENTS);
            if (!result.granted) {
                // User has no permission.
                return;
            }

            const confirmed = await container.dialogService.confirm(
                'ORDER_DETAILS.VOID_ORDER_PROMPT',
                {
                    cancelColor: 'default',
                    cancelLabel: 'ORDER_DETAILS.VOID_ORDER_PROMPT_CANCEL',
                    okColor: 'danger',
                    okLabel: 'ORDER_DETAILS.VOID_ORDER_BTN',
                }
            );
            if (!confirmed) {
                return;
            }

            this.voiding = true;

            // The API voids rather than cancels an order that is not confirmed.
            const voidPromise = container.ordersApi.cancelOrder(this.order.ID);
            container.toastFactory.spinner(
                'ORDER_DETAILS.VOID_ORDER_IN_PROGRESS',
                this.order.bookingRef,
                voidPromise
            );

            try {
                await voidPromise;

                container.toastFactory.success('ORDER_DETAILS.VOID_ORDER_SUCCESS');

                // The Angular OrderDetailCtrl listens for this and reloads the order.
                container.eventBus.broadcast(EventNames.ORDER_VOIDED, this.order);
            } catch (error) {
                container.toastFactory.errorTop(
                    'ORDER_DETAILS.VOID_ORDER_FAIL',
                    error.message
                );
            } finally {
                this.voiding = false;
            }
        },
    },
};
</script>
